import IMPSBaseModel from './imps-base-model';
import { ServiceResult } from './service-result';
import { formatDate } from '../utils/formatter';

export enum CheckOutQuestionKey {
    None = '',
    Followup = 'followup',
    Payment = 'payment',
    PaymentSucceeded = 'payment-succeeded',
    Completed = 'completed',
    Finished = 'finished'
}

export class CheckOutQuestion extends IMPSBaseModel {
    appointmentId: number;

    questionKey: CheckOutQuestionKey = CheckOutQuestionKey.None;
    questionDetail: string = '';
    questionDate: string = '';

    answerKey: string = '';
    answerDetail: Undefinable<string>;
    answerDate: string = '';
    answerDetailDate: Undefinable<string>;

    constructor(
        appointmentId: number,
        questionKey: CheckOutQuestionKey
    ) {
        super();
        this.appointmentId = appointmentId;
        this.questionKey = questionKey;
        this.questionDate = formatDate({
            destFormat: 'YYYY-MM-DDTHH:mm:ss',
            current: true
        });
    }
}

export type CheckOutQuestionResult = ServiceResult<CheckOutQuestion>;
